<div class="card">
  <div class="card-body">
    <div class="d-md-flex align-items-center bg-white p-2">
      <div class="ml-auto mt-3 mt-md-0">
        <!-- Add Contact -->
        <button type="button" (click)="openModal(editTicketModal, null, null)" class="btn btn-cyan rounded-pill p-2"><i
            class="fas fa-plus  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
          <tr>
            <th>Categoria</th>
            <th scope="col">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let co of Categorie ">
            <td (click)="openModal(editTicketModal, co, null)">
              <!-- <img [src]='co.Imagepath' class="rounded-circle mr-2" alt="" height="45" width="45"> -->
              <span class="text-dark font-medium font-16">
                <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                  <i-feather name="info" class="feather-sm"></i-feather>
                </span>
                {{ co.categoria}}
              </span>
            </td>
            <td class="align-middle">
              <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2"
                (click)="openModal(editTicketModal, co, null)">
                <i class="fas fa-pencil-alt"></i>
              </a>
              <a href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)="Delete(co)">
                <i-feather name="trash-2" class="feather-sm"></i-feather>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



<ng-template #editTicketModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Categoria</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="input-group col-12">
        <div class="">
          <label class="input-group-text" for="nome">Nome Categoria:</label>
        </div>
        <input type="text" [(ngModel)]="LabelCategoria" name="nome" class="form-control">
      </div>
      <!-- <div class="col-12">
        <label for="categorie" class="control-label col-form-label">Categorie Padre:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie"
          [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
          (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div> -->
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
      <button type="submit" (click)="saveModalButton()"
        class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>


<ng-template #DeleteCategoriaModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Elimina Categoria</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <label for="categorie" class="control-label col-form-label">Categorie a cui assegnare le categorie
          figlie:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie"
          [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" [settings]="categoriedropdownSettings"
          (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px; margin-top: 25px;">
      <button type="submit" (click)="deleteModalButton()"
        class="ml-auto btn btn-rounded btn-danger p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Elimina </span>
        <i-feather name="trash-2" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>

